import { Record } from "./Record.js";
export class LocationGroup extends Record {
    constructor() {
        super(...arguments);
        this.order = 0;
    }
}
